// Public components
import Popper, { placements } from './Popper';
import Manager from './Manager';
import Reference from './Reference';
export { Popper, placements, Manager, Reference }; // Public types


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/react-popper/lib/esm/index.js
// module id = 1797
// module chunks = 2 4 5